var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechnology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 39,
    viewBox: "0 0 50 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7625 38.481V0H26.322V0.036499L0 15.233L0.0144997 15.258H0V38.481H49.7625ZM26.385 19.9055V1.679L1.4545 16.073V37.027H26.385V21.3595H1.4545V19.9055H26.385ZM42.3675 37.027H48.308V21.3595H27.8395V37.027H33.47V25.7375H42.3675V37.027ZM34.924 27.192V37.027H40.913V27.192H34.924ZM20.631 31.362H7.0895V32.816H20.631V31.362ZM20.631 28.636H7.0895V30.0905H20.631V28.636ZM20.631 25.7375H7.0895V27.192H20.631V25.7375ZM27.8395 1.454V19.9055H48.308V1.454H27.8395ZM42.3675 12.584H33.47V14.0385H42.3675V12.584ZM42.3675 9.8585H33.47V11.3125H42.3675V9.8585ZM42.3675 6.96H33.47V8.414H42.3675V6.96Z",
    fill: "#255056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnology);
export default __webpack_public_path__ + "static/media/technology.d10e2708314c2e9617a155476912074b.svg";
export { ForwardRef as ReactComponent };